/* eslint-disable code-style/no-redundant-folder-suffix */

import { Box } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router";

import { Loader } from "@/atoms";
import { globalData, routesUrlsData } from "@/data";
import { logout } from "@/redux/actions";
import { getCookie } from "@/utils";

export const ProtectedRoute = ({ children }) => {
    const dispatch = useDispatch();

    const loading = useSelector(({ authReducer }) => authReducer.loader);

    const location = useLocation();

    const userCookie = getCookie(globalData.cookieKeys.userId);

    const tokenCookie = getCookie(globalData.cookieKeys.token);

    const isAuthenticated = userCookie && tokenCookie;

    useEffect(
        () => {
            if (!isAuthenticated) dispatch(logout());
        },
        [isAuthenticated, dispatch],
    );

    if (!isAuthenticated) {
        return (
            <Navigate
                state={{ from: location }}
                to={routesUrlsData.auth.login}
                replace
            />
        );
    }

    if (loading) {
        return (
            <Box height="100vh">
                <Loader />
            </Box>
        );
    }

    return children || <Outlet />;
};
